import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import './style.scss';
import Goal from './Goal';
import { GoalShape } from 'entities';
import * as actions from 'actions';

class Goals extends Component {

  renderGoals() {
    return this.props.goals.map((goal, i) => {
      return (
        <Goal
          key={i}
          goal={goal}
          onIncrease={this.props.onGoalIncrease}
          onDecrease={this.props.onGoalDecrease}
        />
      );
    });
  }

  render() {
    return (
      <div className="Goals">
        <table>
          <thead>
            <tr>
              <th>{__('members.goals.yourGoals')}</th>
              <th>{__('members.goals.score')}</th>
            </tr>
          </thead>

          <tbody>
            {this.renderGoals()}
          </tbody>
        </table>
      </div>
    );
  }
}

Goals.propTypes = {
  goals: PropTypes.arrayOf(GoalShape),
  source: PropTypes.string,
  onGoalIncrease: PropTypes.func,
  onGoalDecrease: PropTypes.func
};

const mapStateToProps = (state, ownProps) => {
  const goalsUpdates = ownProps.goals.map(goal => goal.updatedAt);
  goalsUpdates.sort((date1, date2) => date2 - date1);

  return {
    lastUpdated: goalsUpdates[0]
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onGoalDecrease: (goal) => {
      const goalScore = goal.score - 1;
      if (goalScore >= process.env.KOOTH_MIN_GOAL_SCORE) {
        dispatch(actions.goalUpdate(goal.id, goal, {
          score: goalScore
        }, props.source
        ));
      }
    },
    onGoalIncrease: (goal) => {
      const goalScore = goal.score + 1;
      if (goalScore <= process.env.KOOTH_MAX_GOAL_SCORE) {
        dispatch(actions.goalUpdate(goal.id, goal, {
          score: goalScore
        }, props.source
        ));
      }
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Goals);



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/containers/Goals/index.js
 **/